import React, { useEffect, useState } from 'react';
import './Sidebar.css';
import {
  FaTachometerAlt,
  FaCertificate,
  FaClipboardList,
  FaBoxOpen,
  FaChartBar,
  FaLifeRing,
  FaUserCircle,
  FaSignOutAlt,
  FaWallet
} from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logoDark from '../assests/Logo.svg';
import logoLight from '../assests/EarthID Logo - Primary - BLACK.png';
import { getMe } from '../api/loginAPI';
import { getProductsByUserId } from '../api/productApi';
import { publishToHcs } from '../api/auditAPI';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [walletEnabled, setWalletEnabled] = useState(false);
  const [certificateEnabled, setCertificateEnabled] = useState(false);

  const [darkMode, setDarkMode] = useState(document.body.classList.contains('dark-mode'));

  useEffect(() => {
    async function fetchProducts() {
      try {
        const user = await getMe();
        const products = await getProductsByUserId(user.Id);
        setWalletEnabled(products.some(p => p.productName === 'EarthID Wallet'));
        setCertificateEnabled(products.some(p => p.productName === 'Digital Certificate'));
      } catch (err) {
        console.error('❌ Error fetching user or products', err);
      }
    }
    fetchProducts();
  }, []);

// 💡 Listen for class changes to <body> to detect dark mode toggle
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDarkMode(document.body.classList.contains('dark-mode'));
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);


  const handleLogout = async () => {
    localStorage.removeItem('jwt');
    localStorage.removeItem('user');
     const messageObj = {
                        "event": "Logout",
                        "message": `User has logged out.`,
                        "timestamp": new Date().toISOString(),
                        "status": "success"
                      }
                          await publishToHcs(messageObj)
                          console.log('Published audit for Logout')
              
    navigate('/login');
  };

  useEffect(() => {
    async function fetchProducts() {
      try {
        const user = await getMe();
        const products = await getProductsByUserId(user.Id);
        setWalletEnabled(products.some(p => p.productName === 'EarthID Wallet'));
        setCertificateEnabled(products.some(p => p.productName === 'Digital Certificate'));
      } catch (err) {
        console.error('❌ Error fetching user or products', err);
      }
    }
    fetchProducts();
  }, []);

  return (
    <div className="sidebar">
      <div className="logo">
        <img
          src={darkMode ? logoDark : logoLight}
          alt="Earth ID Logo"
          className="logo-img"
        />
      </div>
      <nav>
        <div className="nav-section">
          <Link to="/" className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
            <FaTachometerAlt />
            <span>Dashboard</span>
          </Link>
          <hr className="nav-divider" />
        </div>

        {walletEnabled && (
          <div className="nav-section">
            <Link to="/issuewallet" className={`nav-item ${location.pathname === '/issuewallet' ? 'active' : ''}`}>
              <FaWallet />
              <span>Issue Wallet</span>
            </Link>
            <Link to="/wallets" className={`nav-item ${location.pathname === '/wallets' ? 'active' : ''}`}>
              <FaClipboardList />
              <span>Issued Wallets</span>
            </Link>
            <hr className="nav-divider" />
          </div>
        )}

        {certificateEnabled && (
          <div className="nav-section">
            <Link to="/issue" className={`nav-item ${location.pathname === '/issue' ? 'active' : ''}`}>
              <FaCertificate />
              <span>Issue Certificate</span>
            </Link>
            <Link to="/certificates" className={`nav-item ${location.pathname === '/certificates' ? 'active' : ''}`}>
              <FaClipboardList />
              <span>Issued Certificates</span>
            </Link>
            <hr className="nav-divider" />
          </div>
        )}

        <div className="nav-section">
          <Link to="/products" className={`nav-item ${location.pathname === '/products' ? 'active' : ''}`}>
            <FaBoxOpen />
            <span>Products</span>
          </Link>
          <Link to="/reports" className={`nav-item ${location.pathname === '/reports' ? 'active' : ''}`}>
            <FaChartBar />
            <span>Reports</span>
          </Link>
          <hr className="nav-divider" />
        </div>

        <div className="nav-section">
          <Link to="/support" className={`nav-item ${location.pathname === '/support' ? 'active' : ''}`}>
            <FaLifeRing />
            <span>Support</span>
          </Link>
          <Link to="/profile" className={`nav-item ${location.pathname === '/profile' ? 'active' : ''}`}>
            <FaUserCircle />
            <span>Profile</span>
          </Link>
          <hr className="nav-divider" />
        </div>

        <div className="nav-section">
          <div className="nav-item logout" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Logout</span>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Sidebar;
